import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  retrieveCarrierCompanys({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("carrier/retrieveCarrierCompanys").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveCarrierCompanysByName({ commit } , name) {
    commit("SET_LOADING", true);
    return getAPI("carrier/retrieveCarrierCompanysByName/" + name).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  deleteCarrierCompany({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("carrier/deleteCarrierCompany/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveCarrierCompanyById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("carrier/retrieveCarrierCompanyById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveCarrierCompany({ commit }, carrier) {
    commit("SET_LOADING", true);
    return postAPI("carrier/saveCarrierCompany", carrier).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  countCarrierCompanys({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("carrier/count").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },


};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};